// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__18Y9I","actionsCol":"EnrolledClinics_actionsCol__2-Zpf"};